import { styled } from "@mui/material";

export const VerticalDivider = styled("div")<{ opacity?: number, backgroundColor?: string }>(({ theme, opacity, backgroundColor }) => ({
  width: "1px",
  height: "1rem",
  margin: "0 0.12rem",
  opacity: opacity ?? 1,
  backgroundColor: backgroundColor ?? theme.customColors.exploreCardText
}));
